// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article-box-data {
  background-color: rgba(0, 0, 0, 0) !important;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 25px;
  padding-left: 0px;
  padding-right: 0px;
  margin-right: 0px;
  margin-left: 0px;
}
.article-box-data .article-picture {
  width: 100%;
  max-height: 350px;
  margin-bottom: 25px;
}
.article-box-data .link-box {
  color: black;
  text-decoration: none !important;
}
.article-box-data .link-box:hover {
  color: black;
  text-decoration: none !important;
}
.article-box-data .article-box {
  background-color: rgba(0, 0, 0, 0) !important;
  flex: 1 1;
  align-items: flex-start;
  align-content: flex-start;
  word-break: break-word;
}
.article-box-data .article-box h3 {
  align-self: flex-start !important;
  text-align: left !important;
  padding: 0px !important;
}
.article-box-data .article-box .by-author {
  align-self: flex-start !important;
  text-align: left !important;
  padding: 0px !important;
}
.article-box-data .article-detail {
  background-color: #ffffff !important;
  border-radius: 25px;
  margin-right: 10px;
  margin-bottom: 10px;
  font-size: 15px;
  font-family: Rubik;
  padding: 50px;
  padding-inline: 10px;
}
.article-box-data .article-detail h3 {
  margin-bottom: 25px;
}
.article-box-data .article-detail h5 {
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  margin-bottom: 25px;
}
.article-box-data .article-detail h6 {
  margin-bottom: 25px;
}
.article-box-data .article-detail p {
  font-size: 16px;
}
.article-box-data .more-articles {
  background-color: rgba(0, 0, 0, 0) !important;
  width: 45%;
  align-self: flex-start;
  border-radius: 25px;
  margin-bottom: 10px;
}
.article-box-data .box-more {
  background-color: rgba(0, 0, 0, 0);
  padding: 5px;
  margin: 5px;
  margin-top: 20px;
  font-size: 25px;
  font-family: Rubik;
  align-self: flex-start;
}
.article-box-data .box-data {
  background-color: rgba(137, 1, 53, 0.05);
  padding: 35px;
  margin: 10px;
  border-radius: 5px;
  font-size: 15px;
  font-family: Rubik;
}
.article-box-data .article-preview {
  flex-direction: column;
  justify-content: center;
  width: 100%;
  background-color: rgb(255, 255, 255);
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 30px;
  margin-bottom: 25px;
  cursor: pointer;
}
.article-box-data .article-img-preview {
  width: 100%;
  max-height: 350px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.article-box-data .container-img-article {
  width: 100%;
  max-height: 350px;
  margin-bottom: 25px;
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/views/articles/articlePreview/articlePreview.scss"],"names":[],"mappings":"AAAA;EACC,6CAAA;EACC,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AACF;AACE;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;AACJ;AAEE;EACE,YAAA;EACA,gCAAA;AAAJ;AAGE;EACE,YAAA;EACA,gCAAA;AADJ;AAIE;EACE,6CAAA;EACA,SAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;AAFJ;AAII;EACE,iCAAA;EACA,2BAAA;EACA,uBAAA;AAFN;AAKI;EACE,iCAAA;EACA,2BAAA;EACA,uBAAA;AAHN;AAOE;EACE,oCAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;AALJ;AAOI;EACE,mBAAA;AALN;AAQI;EACE,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBAAA;AANN;AASI;EACE,mBAAA;AAPN;AAUI;EACE,eAAA;AARN;AAYE;EACE,6CAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AAVJ;AAaE;EACE,kCAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAXJ;AAcE;EACE,wCAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAZJ;AAeE;EACE,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,oCAAA;EACA,+BAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAbJ;AAgBE;EACE,WAAA;EACA,iBAAA;EACA,4BAAA;EACA,6BAAA;AAdJ;AAiBE;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;AAfJ","sourcesContent":[".article-box-data {\n\tbackground-color: rgba(0,0,0,0) !important;\n  flex-direction: column;\n  justify-content: flex-start;\n  margin-bottom: 25px;\n  padding-left: 0px;\n  padding-right: 0px;\n  margin-right: 0px;\n  margin-left: 0px;\n\n  .article-picture {\n    width: 100%;\n    max-height: 350px;\n    margin-bottom: 25px;\n  }\n  \n  .link-box {\n    color: black;\n    text-decoration: none !important;\n  }\n  \n  .link-box:hover {\n    color: black;\n    text-decoration: none !important;\n  }\n  \n  .article-box {\n    background-color: rgba(0,0,0,0) !important;\n    flex: 1;\n    align-items: flex-start;\n    align-content: flex-start;\n    word-break: break-word;\n  \n    h3 {\n      align-self: flex-start !important;\n      text-align: left !important;\n      padding: 0px !important;\n    }\n  \n    .by-author {\n      align-self: flex-start !important;\n      text-align: left !important;\n      padding: 0px !important;\n    }\n  }\n  \n  .article-detail {\n    background-color: #ffffff !important;\n    border-radius: 25px;\n    margin-right: 10px;\n    margin-bottom: 10px;\n    font-size: 15px;\n    font-family: Rubik;\n    padding: 50px;\n    padding-inline: 10px;\n  \n    h3 {\n      margin-bottom: 25px;\n    }\n  \n    h5 {\n      padding-right: 0 !important;\n      padding-left: 0 !important;\n      margin-right: 0 !important;\n      margin-left: 0 !important;\n      margin-bottom: 25px;\n    }\n  \n    h6 {\n      margin-bottom: 25px;\n    }\n  \n    p {\n      font-size: 16px;\n    }\n  }\n  \n  .more-articles {\n    background-color: rgb(0, 0, 0, 0) !important;\n    width: 45%;\n    align-self: flex-start;\n    border-radius: 25px;\n    margin-bottom: 10px;\n  }\n  \n  .box-more {\n    background-color: rgb(0, 0, 0, 0);\n    padding: 5px;\n    margin: 5px;\n    margin-top: 20px;\n    font-size: 25px;\n    font-family: Rubik;\n    align-self: flex-start;\n  }\n  \n  .box-data {\n    background-color: rgba(137, 1, 53, 0.05);\n    padding: 35px;\n    margin: 10px;\n    border-radius: 5px;\n    font-size: 15px;\n    font-family: Rubik;\n  }\n  \n  .article-preview {\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    background-color: rgba(255, 255, 255, 1);\n    border-bottom-left-radius: 12px;\n    border-bottom-right-radius: 12px;\n    padding: 30px;\n    margin-bottom: 25px;\n    cursor: pointer;\n  }\n  \n  .article-img-preview {\n    width: 100%;\n    max-height: 350px;\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n  }\n  \n  .container-img-article {\n    width: 100%;\n    max-height: 350px;\n    margin-bottom: 25px;\n    padding: 0 !important;\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
